import React from "react";
import { Truck, Clapperboard, Camera, MapPin, Users, Film } from "lucide-react";
import Editable from "./Editable";

const ICONS = {
  truck: Truck,
  clapperboard: Clapperboard,
  camera: Camera,
  "map-pin": MapPin,
  users: Users,
  film: Film,
};

export const Services = ({ data = {}, editable, onChange }) => {
  const items = data.items || [];
  const setField = (k, v) => onChange && onChange({ ...data, [k]: v });
  const setItem = (i, key, v) => {
    const next = items.map((it, idx) => (idx === i ? { ...it, [key]: v } : it));
    setField("items", next);
  };

  return (
    <section id="services" className="relative bg-onyx-900 py-28 md:py-36" data-testid="services-section">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="mb-16 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <div className="h-px w-10 bg-gold" />
              <Editable
                editable={editable}
                value={data.eyebrow}
                onChange={(v) => setField("eyebrow", v)}
                className="font-cinzel text-[11px] tracking-[0.4em] uppercase text-gold"
                testId="services-eyebrow"
              />
            </div>
            <Editable
              as="h2"
              editable={editable}
              value={data.title}
              onChange={(v) => setField("title", v)}
              className="font-display text-4xl md:text-6xl text-ivory max-w-2xl leading-[1.05]"
              testId="services-title"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 gap-px bg-gold/15 sm:grid-cols-2 lg:grid-cols-3" data-testid="services-grid">
          {items.map((it, i) => {
            const Icon = ICONS[it.icon] || Film;
            return (
              <div
                key={it.title || `service-${i}`}
                className="group relative bg-onyx-900 p-10 transition-colors duration-500 hover:bg-onyx-800"
                data-testid={`service-card-${i}`}
              >
                <Icon size={36} className="text-gold transition-transform duration-500 group-hover:scale-110" strokeWidth={1.2} />
                <Editable
                  as="h3"
                  editable={editable}
                  value={it.title}
                  onChange={(v) => setItem(i, "title", v)}
                  className="mt-7 font-display text-2xl md:text-3xl text-ivory"
                  testId={`service-title-${i}`}
                />
                <Editable
                  as="p"
                  multiline
                  editable={editable}
                  value={it.desc}
                  onChange={(v) => setItem(i, "desc", v)}
                  className="mt-4 text-ivory/60 text-sm leading-relaxed"
                  testId={`service-desc-${i}`}
                />
                <div className="mt-8 h-px w-12 bg-gold/40 transition-all duration-500 group-hover:w-24 group-hover:bg-gold" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
